import type { SVGProps } from 'react';

export const SvgImgIllustKabukatsu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={92} height={78} viewBox="0 0 92 78" fill="none" {...props}>
    <path
      fill="#FBDED7"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M46 72.047 1 46.066l45-25.98 45 25.98z"
    />
    <path
      fill="url(#SvgImgIllustKabukatsu3_svg__a)"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M1 50.605v-4.54l45 25.982v4.538z"
    />
    <path
      fill="url(#SvgImgIllustKabukatsu3_svg__b)"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M91 46.068v4.538l-45 25.98v-4.538z"
    />
    <path
      fill="#FFC1C1"
      d="m36.632 18.495-4.857 2.828c2.2 1.274 2.209 3.33.027 4.596s-5.736 1.266-7.945 0L19 28.747 45.305 43.93l17.632-10.253z"
    />
    <path
      fill="#fff"
      d="M62.937 33.676 45.305 43.93l10.432 6.024 4.857-2.828c-2.2-1.275-2.209-3.33-.027-4.597 2.19-1.274 5.746-1.274 7.945 0L73.37 39.7z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m73.37 39.7-4.858 2.827c-2.2-1.275-5.754-1.275-7.945 0-2.19 1.275-2.173 3.331.027 4.597l-4.857 2.828L19 28.738l4.857-2.828c2.2 1.274 5.755 1.274 7.945 0s2.173-3.331-.027-4.597l4.857-2.828L73.36 39.69z"
    />
    <path
      fill="#FFC1C1"
      d="m36.632 12.794-4.857 2.827c2.2 1.275 2.209 3.331.027 4.597s-5.736 1.266-7.945 0L19 23.046l26.305 15.182 17.632-10.253z"
    />
    <path
      fill="#fff"
      d="M62.937 27.985 45.305 38.237l10.432 6.025 4.857-2.828c-2.2-1.275-2.209-3.331-.027-4.597 2.19-1.275 5.746-1.275 7.945 0l4.857-2.828z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m73.37 34.008-4.858 2.828c-2.2-1.275-5.754-1.275-7.945 0-2.19 1.275-2.173 3.33.027 4.596l-4.857 2.828L19 23.047l4.857-2.828c2.2 1.275 5.755 1.275 7.945 0s2.173-3.33-.027-4.597l4.857-2.828L73.36 34z"
    />
    <path
      fill="#FFC1C1"
      d="M36.632 7.102 31.775 9.93c2.2 1.275 2.209 3.33.027 4.597-2.181 1.266-5.736 1.266-7.945 0L19 17.355l26.305 15.181 17.632-10.253z"
    />
    <path
      fill="#fff"
      d="M62.937 22.294 45.305 32.546l10.432 6.024 4.857-2.828c-2.2-1.275-2.209-3.33-.027-4.596 2.19-1.275 5.746-1.275 7.945 0l4.857-2.829z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m73.37 28.308-4.858 2.828c-2.2-1.275-5.754-1.275-7.945 0-2.19 1.274-2.173 3.33.027 4.596l-4.857 2.828L19 17.355l4.857-2.828c2.2 1.275 5.755 1.275 7.945 0s2.173-3.331-.027-4.597l4.857-2.828L73.36 28.308z"
    />
    <path
      fill="#FFC1C1"
      d="M36.632 1.41 31.775 4.24c2.2 1.274 2.209 3.33.027 4.596s-5.736 1.266-7.945 0L19 11.663l26.305 15.182 17.632-10.253z"
    />
    <path
      fill="#fff"
      d="M62.937 16.59 45.305 26.843l10.432 6.024 4.857-2.828c-2.2-1.275-2.209-3.33-.027-4.597 2.19-1.274 5.746-1.274 7.945 0l4.857-2.828z"
    />
    <path
      stroke="#FF0019"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="m73.37 22.616-4.858 2.828c-2.2-1.275-5.754-1.275-7.945 0-2.19 1.275-2.173 3.33.027 4.597l-4.857 2.828L19 11.663l4.857-2.828c2.2 1.275 5.755 1.275 7.945 0s2.173-3.33-.027-4.596l4.857-2.828L73.36 22.616z"
    />
    <path
      fill="#FF0019"
      d="M61.995 18.035a.92.92 0 0 1-.781-.449.896.896 0 0 1 .323-1.23l.78-.449a.896.896 0 0 1 1.23.324.896.896 0 0 1-.322 1.23l-.782.448a.9.9 0 0 1-.448.126M49.35 25.387a.92.92 0 0 1-.781-.449.896.896 0 0 1 .323-1.23l1.4-.817a.896.896 0 0 1 1.23.324.896.896 0 0 1-.322 1.23l-1.401.816a.9.9 0 0 1-.449.126m4.21-2.45a.91.91 0 0 1-.78-.45.896.896 0 0 1 .323-1.23l1.4-.817a.897.897 0 0 1 1.23.323.896.896 0 0 1-.323 1.23l-1.4.818a.9.9 0 0 1-.45.125m4.22-2.452a.92.92 0 0 1-.78-.449.896.896 0 0 1 .322-1.23l1.4-.817a.896.896 0 0 1 1.23.324.896.896 0 0 1-.322 1.23l-1.4.817a.9.9 0 0 1-.45.125M45.772 27.47a.91.91 0 0 1-.781-.448.896.896 0 0 1 .323-1.23l.772-.45a.896.896 0 0 1 1.23.324.896.896 0 0 1-.323 1.23l-.772.449a.9.9 0 0 1-.45.126"
    />
    <defs>
      <linearGradient
        id="SvgImgIllustKabukatsu3_svg__a"
        x1={24.414}
        x2={21.769}
        y1={59.769}
        y2={64.277}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.29} stopColor="#F5B3A4" />
        <stop offset={0.75} stopColor="#F9D2C8" />
        <stop offset={1} stopColor="#FBDED7" />
      </linearGradient>
      <linearGradient
        id="SvgImgIllustKabukatsu3_svg__b"
        x1={68.63}
        x2={68.404}
        y1={79.837}
        y2={47.631}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#F29E8A" />
        <stop offset={0.51} stopColor="#ED8B7D" />
        <stop offset={1} stopColor="#EB7D74" />
      </linearGradient>
    </defs>
  </svg>
);
